<template>
    <div class="user-detail-container">
        <dl class="cl">
            <dt class="fl">昵称:</dt>
            <dd>{{ userInfo.nickname }}</dd>
        </dl>
        <dl class="cl" style="color: #F56C6C">
            <dt class="fl">重复用户:</dt>
            <dd>{{sameIds ? '是' : '否'}}</dd>
        </dl>
        <el-form label-width="120px">
            <el-form-item label="入驻状态">
                <el-radio-group v-model="userInfo.checkStatus">
                    <el-radio-button label="-2">审核未通过</el-radio-button>
                    <el-radio-button label="0">未认证</el-radio-button>
                    <el-radio-button label="1">未审核</el-radio-button>
                    <el-radio-button label="2">已认证</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="驳回原因" v-if="userInfo.checkStatus == -2">
                <el-select v-model="userInfo.rejectReason" multiple>
                    <el-option v-for="val,key in reasons" :key="val.id" :value="val.reason" :label="val.reason"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="update">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import api from '../api'
// import request from '../request'

// const check = '/user/updateUserStatus'

const {
    user
} = api

export default {
    name: '',
    data() {
        return {
            data: {},
            userInfo: {}, // 用户信息
            sameIds: {},
            status: {
                0: '未认证',
                1: '审核中',
                2: '已认证',
            },
            isSubmiting: false,
            reasons: []
        }
    },
    computed: {
        userId() {
            return this.$route.query.userId;
        },
    },
    methods: {
        async getUserById() {
            let {
                data: {
                    code,
                    data
                }
            } = await api.user.vertifyInfo({
                aesId: this.userId
            })
            if (code === 200) {
                this.data = data
                this.userInfo = data.user;
                this.sameIds = data.sameIds;
            }
        },
        async getRejectReason() {
            let {
                data: {
                    code,
                    data
                }
            } = await api.common.getReasons({type: 4})
            if (code === 200) {
                this.reasons = data;
            }
        },
        goBack() {
            this.$router.go(-1)
        },
        async update() {
            if (this.isSubmiting) return false;
            this.isSubmiting = true;
            let {
                data: {
                    code
                }
            } = await user.check({
                aesId: this.userId,
                status: this.userInfo.checkStatus,
                rejectReason: this.userInfo.checkStatus == -2 ? this.userInfo.rejectReason : [],
            })
            if (code === 200) {
                this.$message.success('更新用户成功')
                this.getUserById()
            }
            this.isSubmiting = false;
        },
    },
    created() {
        this.getUserById()
        this.getRejectReason();
    },
}
</script>
<style scoped>
.user-detail-container .user-detail-item {
    margin-top: 10px;
    margin-bottom: 10px;
}

.user-detail-container dl dt {
    width: 120px;
    text-align: right;
    margin-right: 20px;
}
.el-select {
    width: 500px;
}
</style>


// WEBPACK FOOTER //
// src/views/user/user-detail.vue